module.exports = __webpack_public_path__ + "static/media/emplacement-1.2a457006.svg";